export default __webpack_public_path__ + "static/media/vaksinasi.6572e51a.png";